"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUnavailableRegionsFromCartLineProperties = exports.addUnavailableRegionsToCartLineProperties = void 0;
var regions_unavailable_1 = require("@launchedla/hb-shared/dist/regions-unavailable");
var cartLineUnavailableRegionsPropertyKey = 'unavailable_regions';
/** Does not modify `properties`, instead returns a new shallow clone of it with the new property added to the clone. */
var addUnavailableRegionsToCartLineProperties = function (properties, tags) {
    var _a;
    return __assign(__assign({}, properties), (_a = {}, _a[cartLineUnavailableRegionsPropertyKey] = (0, regions_unavailable_1.getUnavailableRegions)(tags), _a));
};
exports.addUnavailableRegionsToCartLineProperties = addUnavailableRegionsToCartLineProperties;
var getUnavailableRegionsFromCartLineProperties = function (properties) {
    // Can be undefined because not all of our inputs to the cart set this property.
    var unavailableRegions = properties[cartLineUnavailableRegionsPropertyKey];
    // Standardize an undefined property as an empty array for the benefit of the caller.
    return unavailableRegions || [];
};
exports.getUnavailableRegionsFromCartLineProperties = getUnavailableRegionsFromCartLineProperties;
